import React from 'react';
import { useTranslation } from 'react-i18next';
import PrivateDiscussionIcon from 'public/images/icons/privateDiscussion.svg';

const PrivateGroupThreadWarning: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div data-testid="thread-detail-no-access-warning" className="container mb-4">
      <div className="flex flex-row justify-center">
        <div className="mt-[88px] flex flex-col items-center justify-center gap-y-1.5">
          <img className="h-24 w-24" src={PrivateDiscussionIcon.src} alt="no discussion" />
          <h1>{t('threadDetail_private_group_no_access_title')}</h1>
          <h4>{t('threadDetail_private_group_no_access_description')}</h4>
        </div>
      </div>
    </div>
  );
};
export default PrivateGroupThreadWarning;
